"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalInsightDimensionTypeToJSON = exports.InternalInsightDimensionTypeFromJSONTyped = exports.InternalInsightDimensionTypeFromJSON = exports.InternalInsightDimensionType = void 0;
/**
 *
 * @export
 */
exports.InternalInsightDimensionType = {
    Age: 'AGE',
    Country: 'COUNTRY',
    Gender: 'GENDER',
    Genre: 'GENRE',
    Placement: 'PLACEMENT',
    Platform: 'PLATFORM'
};
function InternalInsightDimensionTypeFromJSON(json) {
    return InternalInsightDimensionTypeFromJSONTyped(json, false);
}
exports.InternalInsightDimensionTypeFromJSON = InternalInsightDimensionTypeFromJSON;
function InternalInsightDimensionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.InternalInsightDimensionTypeFromJSONTyped = InternalInsightDimensionTypeFromJSONTyped;
function InternalInsightDimensionTypeToJSON(value) {
    return value;
}
exports.InternalInsightDimensionTypeToJSON = InternalInsightDimensionTypeToJSON;
